import apiClient from '@/api/client';
import type { TokenEvent, SendTokensRequest } from '@/types/token';

export const sendTokens = async (data: SendTokensRequest): Promise<void> => {
  await apiClient.post('/tokens/send', data);
};

export const getTokenHistory = async (): Promise<TokenEvent[]> => {
  const response = await apiClient.get<TokenEvent[]>('/tokens/history');
  return response.data;
};
